export default class UserDTO {
    username: string
    password: object

    constructor(username, password) {
        this.username = username
        this.password = password
    }
}
